import {
  PracticeQuestionType,
  formatModuleTypeCountLabel,
  getNonZeroQuestionTypeEntries,
  practiceQuestionTypeLabel,
  QuestionTypeCounts,
} from "../../utils/practiceQuestionTypes";
import "./ModuleTypeCountPills.scss";

type ModuleTypeCountPillsProps = {
  counts?: Partial<QuestionTypeCounts> | null;
  className?: string;
};

function typeModifier(type: PracticeQuestionType): string {
  return practiceQuestionTypeLabel(type).toLowerCase().replace(/\s+/g, "-");
}

export function ModuleTypeCountPills({
  counts,
  className,
}: ModuleTypeCountPillsProps) {
  const entries = getNonZeroQuestionTypeEntries(counts);
  if (entries.length === 0) {
    return null;
  }

  return (
    <span
      className={["module-type-count-pills", className].filter(Boolean).join(" ")}
    >
      {entries.map(({ type, count }) => (
        <span
          key={type}
          className={`module-type-count-pill module-type-count-pill--${typeModifier(type)}`}
        >
          {formatModuleTypeCountLabel(type, count)}
        </span>
      ))}
    </span>
  );
}
